module.exports = __webpack_public_path__ + "img/palettes_en.f5a0321.jpg";